import {Injectable} from '@angular/core';

import {Apollo, gql} from "apollo-angular";
import {map, Observable} from "rxjs";
import {PageInput, PageResult} from "../../base/domain/page.model";
import {AspectSystem, AspectSystemId} from "../domain/aspect-system.model";


@Injectable({
    providedIn: 'root'
})
export class AspectSystemService {

    constructor(private apollo: Apollo) {
    }

    getAspectSystems(page?: PageInput): Observable<PageResult<AspectSystem>> {
        if (page == null) {
            page = {
                page: 0
            }
        }
        return this.apollo.query<{ aspectSystems: PageResult<AspectSystem> }>({
            query: gql`query aspectSystems($page: PageInput!){
                aspectSystems(page: $page) {
                    total
                    page
                    pageSize
                    hasMore
                    content {
                        id
                        name
                        aspectGroup
                        aspectValue
                    }
                }
            }`,
            variables: {
                page: page
            }
        }).pipe(map(o => o.data.aspectSystems));
    }

    getAspectSystem(aspectSystemId: AspectSystemId): Observable<AspectSystem> {
        return this.apollo.query<{ aspectSystem: AspectSystem }>({
            query: gql`query aspectSystems($id: String!){
                aspectSystem(id: $id) {
                    id
                    name
                    aspectValue
                    aspectGroup

                }
            }`,
            variables: {
                id: aspectSystemId
            }
        }).pipe(map(o => o.data.aspectSystem));
    }

}
